//
//
//
//

export default {
  props: {
    barData: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      xData: [],
      data1: [],
      data2: [],
      barChart: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.barChart?.resize()
    },
    barData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.barChart?.clear() // 清空当前实例
    this.barChart?.dispose() // 销毁图表
    this.barChart = null
  },
  methods: {
    getData () {
      this.xData = []
      this.data1 = []
      this.data2 = []
      this.barData?.forEach((item) => {
        this.xData.push(item.date)
        this.data1.push({
          name: item.date,
          type: this.$t('28661'),
          value: item.deposit
        })
        this.data2.push({
          name: item.date,
          type: this.$t('28662'),
          value: item.withdraw
        })
      })
      this.getBarCharts()
    },
    getBarCharts () {
      if (!this.barChart) this.barChart = this.$echarts.init(document.getElementsByClassName('fundsFlow-bar-charts')[0])

      const option = {

        tooltip: {
          trigger: 'axis',
          confine: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          padding: [8, 12],
          borderWidth: 0,
          borderRadius: 4,
          axisPointer: {
            type: 'none'
          },
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item">${params[0].name}</div>
             <div class="item"><span class="dot" style="background-color:${params[0].color}"></span><span>${params[0].data.type}: ${this.num2CurrencyNo(Math.abs(params[0].value))} ${params[0].seriesName}</span></div>
             <div class="item"><span class="dot" style="background-color:${params[1].color}"></span><span>${params[1].data.type}: ${this.num2CurrencyNo(Math.abs(params[1].value))} ${params[1].seriesName}</span></div>
            </div>`
          }
        },
        axisPointer: {
          link: { xAxisIndex: 'all' }
        },
        xAxis: [{

          gridIndex: 0,
          show: true,
          data: this.xData,
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'

            }
          }
        }, {
          z: 9,
          show: true,
          gridIndex: 1,
          data: this.xData,
          position: 'bottom',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: 'rgba(41, 41, 41, 1)'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'

            }
          },
          axisLabel: {
            // formatter: (value) => {
            //   return value.slice(5, 10)
            // }
          }
        }],
        yAxis: [{
          type: 'value',
          position: 'left',
          splitNumber: 2,
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'

            }
          },
          minInterval: 1,
          axisLabel: {
            formatter: (value) => {
              // return value
              if (value === 0) {
                return 0
              } else {
                return this.formatDecimal(Math.abs(value / 1000000), 0) + 'm'
              }
            }
          }
        }, {
          gridIndex: 1,
          position: 'left',
          splitNumber: 2,
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'

            }
          },
          minInterval: 1,
          axisLabel: {
            formatter: (value) => {
              // return value
              if (value === 0) {
                return 0
              } else {
                return this.formatDecimal(Math.abs(value / 1000000), 0) + 'm'
              }
            }
          }

        }],
        grid: [{
          // containLabel: true,
          top: '10%',
          left: '45px',
          right: '5%',
          bottom: '50%'

        }, {
          // containLabel: true,
          top: '50%',
          left: '45px',
          right: '5%',
          bottom: '13%'

        }],
        series: [{
          xAxisIndex: 0,
          yAxisIndex: 0,
          name: 'USD',
          type: 'bar',
          barMaxWidth: '16px',

          itemStyle: {
            color: 'rgba(46, 153, 135, 1)'
          },
          emphasis: {
            itemStyle: {
              color: 'rgba(46, 153, 135, 0.7)'
            }
          },

          data: this.data1
        },
        {
          xAxisIndex: 1,
          yAxisIndex: 1,
          name: 'USD',
          type: 'bar',
          barMaxWidth: '16px',
          itemStyle: {
            color: 'rgba(199, 52, 76, 1)'
          },
          emphasis: {
            itemStyle: {
              color: 'rgba(199, 52, 76, 0.7)'
            }
          },

          data: this.data2
        }
        ]
      }

      this.barChart?.clear()
      this.barChart?.setOption(option, true)
    }
  }
}
